module.exports = __webpack_public_path__ + "img/logo-horizontal.2ad95a8a.svg";